import Icon from 'components/Icon';
import { listItems } from './constants';
import colors from 'config/theme/colors';

export const HowItWorks = () => {
  return (
    <div className="how-it-works-container">
      <div className="how-it-works-title">
        <span className="eyebrow-text color-white">How It Works</span>
        <span className="h2-dtm color-white">Set it and Forget it</span>
      </div>
      <div className="how-it-works-items">
        {listItems.map(item => (
          <div className="how-it-work-item" key={item.id}>
            <div className="how-it-work-item-icon">
              <Icon
                name={item.icon}
                color={colors.electricBlue}
                size={30}
                style={item.id === 3 ? { transform: 'rotate(-45deg)' } : undefined}
              />
            </div>
            <span className="h4-text color-white">{item.title}</span>
            <span className="body-text color-white">{item.subtitle}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
